import { DEBUG } from "../../utils";

const randomGenerator = (max,min) => {
    return Math.floor(Math.random()*(max-min)+min)
}

const blogTimeFormat = (dateString) => {
    const entryDate = new Date(dateString); // Convert the date string to a Date object
    const currentDate = new Date(); // Get the current date and time

    const timeDifference = currentDate - entryDate; // Time difference in milliseconds
    const hoursDifference = Math.floor(timeDifference / (1000 * 60 * 60)); // Convert milliseconds to hours

    if (hoursDifference < 24) {
        return `${hoursDifference} hours ago`;
    } else {
        return entryDate.toLocaleString('en-US'); // Return the local time string in 'en-US' format
    }
}

    const getNewsAPIData = () => { 
        const searchTerms = [
            "Democrat",
            "anti-Trump",
            "Israel",
            "Hamas",
            "Ukraine",
            "Russia",
            "war",
            "protest",
            "donation",
        ];

        const apiToken = "679yO9RDGmpPEsu5d1V3Vsr3d42WzSGDDkrz6ZQA"
        
        // Join the terms into a single search query, separated by commas (OR search)
        // const category = getRandomInt(0,searchTerms.length)

        const params = new URLSearchParams({
            api_token: apiToken,
            limit: '25',
            categories: 'politics,business,health,tech',
            language: 'en',
            search: searchTerms[0]
        });

        fetch(`https://api.thenewsapi.com/v1/news/top?${params.toString()}`)
        .then(res => res.json())
        .then(resObj => {
            const data = resObj.data
            DEBUG && console.log(data)
            // APINewsUpdate.current = data
            // setUpdateAPINews(true)
        })
        .catch(err => {
            DEBUG && console.error(err)
        });
    }

export {
    randomGenerator,
    getNewsAPIData,
    blogTimeFormat,
}